import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Register } from "../../../api";
import PhoneInputW from "../../../Reservation/PhoneInput";

import { useTranslation } from "../../../../context/TranslationContext";

const StepPhone = ({ onNext }) => {
  const {
    phone: phoneLabel,
    continue: continueBtn,
    phoneRequired,
    phoneInvalid,
    operationFailed,
  } = useTranslation();

  const Step1Schema = Yup.object().shape({
    phoneNumber: Yup.string()
      .required(phoneRequired)
      .matches(/^[+0-9]+$/, phoneInvalid)
      .min(10, phoneInvalid),
  });

  const handleStep1Submit = async (values, actions) => {
    try {
      const response = await Register({ phoneNumber: values.phoneNumber }, 1);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        onNext(values.phoneNumber);
      }
    } catch (error) {
      toast.error(operationFailed);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ phoneNumber: "" }}
      validationSchema={Step1Schema}
      onSubmit={handleStep1Submit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} className="mb-6">
          <div className="relative z-0 mb-6 w-full group h-[60px]">
            <PhoneInputW
              label={phoneLabel}
              validname="phoneNumberValid"
              isrequired="required"
              name="phoneNumber"
              mode="simple"
            ></PhoneInputW>
            {props.errors.phoneNumber && props.touched.phoneNumber && (
              <span className="text-xs text-red-500 mt-1">
                {props.errors.phoneNumber}
              </span>
            )}
          </div>
          <button
            disabled={props.isSubmitting || !props.isValid || !props.dirty}
            type="submit"
            className="w-full text-white px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm disabled:opacity-60"
          >
            {continueBtn}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default StepPhone;
